<template>
  <div class="h-toolbarBg">
    <ejs-toolbar ref="toolBarForTask">
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-search' :tooltipText='$t("MML.queryData")' :click='buttonClick' operate='query'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("MML.uploadCfgFile")' :click='buttonClick' operate='addDialog'></e-item>
        <e-item v-show='showRecover' prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("MML.recover")' :click='buttonClick' operate='recoverDialog'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-batch-upload' :tooltipText='$t("MML.batchRecover")' :click='buttonClick' 　operate='bachRecover'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ToolBarForGnbPmDataQueryRightList',
  data() {
    return {
     showRecover: false
    };
  },
  props: [
    'enableStatus'
  ],
  methods: {
    buttonClick(args){
      this.$parent.methodList(args.item.operate);
    }
  },
  watch: {
    enableStatus(enableStatus){
      switch (enableStatus) {
        case '0': //未查询 恢复关闭
          this.$refs.toolBarForTask.enableItems([0], true);
          this.$refs.toolBarForTask.enableItems([1,2,3], false);
          break;
        case '1': //查询后恢复开启
          this.$refs.toolBarForTask.enableItems([0, 1, 2, 3], true);
          //this.$refs.toolBarForTask.enableItems([1], false);
          break;
        default:
          this.$refs.toolBarForTask.enableItems([0], true);
          this.$refs.toolBarForTask.enableItems([1, 2, 3], false);
          break;
      }
    }
  },
  mounted() {
      this.$refs.toolBarForTask.enableItems([0], true);
      this.$refs.toolBarForTask.enableItems([1,2,3], false);
  }
};
</script>

<style>

</style>
